const topAir = (() => {

  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {


    gsap.set([".spot", ".txt-img"], {
      opacity: 0,
    });
    gsap.set(".txt-img", {
      opacity: 0,
      y: 50,
    });
    let AirWrap = document.querySelectorAll('.sec-intro');

    const airTL = gsap.timeline({
      scrollTrigger: {
        trigger: AirWrap,
        start: "55% 50%",
        // markers: true,
      },
    });

    airTL.to(".line1",{
      clipPath: "polygon(55% 66%, 10% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 66%)",
      duration: 0.8,
    });
    airTL.to(".line2",{
      clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
      duration: 0.8,
    });
    airTL.to(".spot",{
      opacity: 1,
      duration: 1,
    },">-0.4");
    airTL.to(".txt-img",{
      opacity: 1,
      y: 0,
      duration: 1.6,
    });
    




  }
})();
export default topAir;